import { tns } from 'tiny-slider/src/tiny-slider';

const options = {
    mode: 'gallery',
    speed: 600,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayButtonOutput: false,
    controls: false,
    items: 1,
    loop: false,
    mouseDrag: true,
    nav: true,
    slideBy: 1,
    rewind: true,
};

function init() {
    const elements = document.querySelectorAll('[data-slider="offer"]');

    [...elements].forEach((element) => {
        tns({
            ...options,
            navContainer: element.parentElement.querySelector(
                '.offer-slider__nav'
            ),
            container: element,
        });
    });
}

export default {
    init,
};
